import { Dispatch } from '../../../../../types/actions';
import { TSnackbarId } from '../../store/types';
import { deleteSnackbar as deleteSnackbarAction } from '../../store/actions/deleteSnackbar';

export const deleteSnackbar = (
    snackbarId: TSnackbarId
) => {
    return (dispatch: Dispatch) => {
        dispatch(deleteSnackbarAction(snackbarId));
    }
};
